import { PortfolioUtilities as portfolioUtilities } from "@common/portfolio.utilities";
import { PortfolioRepo as portfolioRepo } from "@services/portfolio.repo";
import { portfolioSelectorService } from "../../portfolioSelector";
import * as echarts from "echarts";

class PortfolioMauritiusPreciousMetalsController {
  chartPreciousMetalsHeight: any;
  public preciousMetalItems: any;
  public preciousMetalsTotal: any = 0;

  public preciousMetalsPieChart: any;
  public preciousMetalsPieChartOptions: any;
  public preciousMetalsPieChartData: any;

  /** @ngInject */
  constructor(
    private portfolioRepo: portfolioRepo,
    private portfolioUtilities: portfolioUtilities,
    private portfolioSelectorService: portfolioSelectorService,
    private $timeout: ng.ITimeoutService,
    private notifyjs
  ) {
    var that = this;

    this.portfolioSelectorService.registerCallback(
      "portfolio.mauritius.preciousmetals",
      () => {
        this.updateData();
      }
    ); // Need to wrap it in a fat arrow functiom to get the correctly scoped this

    that.updateData();
  }

  public formatCurrency() {
    if (!this.portfolioSelectorService.isLoading) {
      return this.portfolioUtilities.formatCurrency(
        this.portfolioSelectorService.getSelectedCurrency()
      );
    } else {
      return "";
    }
  }

  getPreciousMetalPercentage(preciousMetal: any) {
    return (preciousMetal.marketValue / this.preciousMetalsTotal) * 100;
  }

  public scrollToElement(elementId: string) {
    var that = this;
    this.$timeout(function () {
      that.portfolioUtilities.scrollToElement(elementId);
    }, 220);
  }

  public initialisePieChart() {
    // need to put the initialisation of the pie chart in a function because the dom element is not available till
    // the time you have clicked on the pie chart tab.
    var that = this;
    that.preciousMetalsPieChart = echarts.init(
      document.getElementById("precious-metals-pie-chart")
    );
    that.preciousMetalsPieChartOptions = {
      tooltip: {
        trigger: "item",
        formatter: "{b} : {d}%",
      },
      color: ["#ffa500", "#ffb732", "#ffc966"],
      series: {
        type: "pie",
        radius: ["40%", "70%"],
        center: ["50%", "50%"],
        labelLine: {
          normal: {
            show: true,
          },
        },
        data: that.preciousMetalsPieChartData,
      },
    };
    that.preciousMetalsPieChart.setOption(that.preciousMetalsPieChartOptions);
  }

  updateData() {
    // Precious Metal data
    var that = this;

    this.portfolioSelectorService.setIsLoading(true);

    that.portfolioRepo
      .getPortfolioPreciousMetalItems(
        this.portfolioSelectorService.getSelectedCurrency(),
        "LOCAL",
        this.portfolioSelectorService.getSelectedPortfolios()
      )
      .then((val) => {
        this.preciousMetalItems = val.data;
        that.scrollToElement("preciousMetals");

        that.preciousMetalsPieChartData = new Array();
        for (var s of this.preciousMetalItems) {
          this.preciousMetalsTotal += s.marketValue;
          that.preciousMetalsPieChartData.push({
            name: s.preciousMetalItem.name,
            value: s.marketValue,
          });
        }
        this.portfolioSelectorService.setIsLoading(false);
      })
      .catch(() => {
        this.portfolioSelectorService.setIsLoading(false);
        this.notifyjs(
          "The commodities data for the selected portfolios could not be loaded. Please try again later or contact the System Administrator.",
          "error"
        );
      });
  }
}

export const portfolioMauritiusPreciousMetals: angular.IComponentOptions = {
  template: require("../portfolio.mauritius.preciousmetals/portfolio.mauritius.preciousmetals.html"),
  controller: PortfolioMauritiusPreciousMetalsController,
};



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.mauritius/portfolio.mauritius.preciousmetals/portfolio.mauritius.preciousmetals.ts